<template>
  <RouterLink
    :to="to"
    :target="target"
    class="block no-underline py-1.5 px-2.5 border-b last:border-b-0 lg:border-0 duration-200 group
      hover:bg-secondary-light/15 h-fit font-medium"
    :class="{ '!bg-[#FFFFFF29] !border-[#FFFFFF29]': active }"
  >
    <span class="text-sm block mb-0 text-white">
      {{ text }}
    </span>
  </RouterLink>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  to: {
    type: Object,
    default: () => ({}),
  },
  text: {
    type: String,
    default: null,
  },
  target: {
    type: String,
    default: null,
  },
});

const route = useRoute();

const active = computed(() => route.name === props.to.name);
</script>
